export default __webpack_public_path__ + "static/media/quotegen.a6e2d2c9.png";